<n-card
  :id="cardId"
  dir="rtl"
  :class="[cardClassName, 'n-shadow-none']"
>
  <n-icon-featured
    circle
    color="success"
    :name="iconName"
    v-if="iconName"
  />

  <div class="n-flex n-flex-column n-gap-md n-flex-grow">
    <h2 class="n-text-lg n-font-weight-bold">{{ title }}</h2>

    <p class="n-m-0 n-text-md">
      {{ description }}
    </p>
  </div>

  <slot name="actions" v-if="enableActions">
    <n-btn
      variant="primary" 
      :id="cardActionId"
      :aria-label="$t('useTheService')"
      @click="onActionClick()"
    >
      {{$t('useTheService')}}
    </n-btn>
  </slot>
  </div>
</n-card>
